import React, { useState } from "react";
import { ScannerForm } from "../../../components/form";
import { userClientDb } from "../../auth/selectors/userSelector";
import { useSelector } from "react-redux";
import * as modules from "../../../utils/modules";
import {
  getProductInfoByBarcode,
  getProductInfoCustom,
} from "../../api/productInfo";
import { InfiniteScrollList } from "../../../components/table";
import { Card, CardMedia, Backdrop } from "@mui/material";
import useProductInfoFormStyles from "../css/useProductInfoFormStyles";
import { useDoubleTap, useLocalStorage } from "../../../hooks";
import { useTranslation } from "react-i18next";
import { moduleType } from "../../../utils/modules";
import DataView, { DataViewItemType } from "../../../components/DataView";

function ProductInfoForm() {
  const [data, setData] = useState<{ property: string; value: any }[]>();
  const userDb = useSelector(userClientDb);
  const userDbId = userDb ? userDb.id : 0;
  const [zoomImage, setZoomImage] = useState(false);
  const { classes } = useProductInfoFormStyles();
  const [imageLink, setImageLink] = useState("");
  const [schema, setSchema] = useState<DataViewItemType[]>();
  const divRef = React.useRef<HTMLDivElement>(null);
  const params: {
    module: moduleType;
    cellType: "info";
    ref: React.RefObject<HTMLDivElement | null>;
  } = {
    module: modules.MODULE_PRODUCT,
    cellType: "info",
    ref: divRef,
  };

  const [isCustomProc] = useLocalStorage("productCustomProc");
  const [translate] = useTranslation();

  const zoom = () => setZoomImage(!zoomImage);
  const [refCallback] = useDoubleTap(zoom);
  const [refCallback2] = useDoubleTap(zoom);

  const updateData = React.useCallback((updatedData: any) => {
  if (!updatedData || updatedData.length === 0 || !updatedData[0]) {
    setSchema(undefined);
    setData([]);
    setImageLink("");
    return;
  }

  const firstItem = updatedData[0];

  const isFullSchema =
    "type" in firstItem && "key" in firstItem && "value" in firstItem;

  if (isFullSchema) {
    const schemaArray: DataViewItemType[] = Array.isArray(updatedData)
      ? updatedData
      : [updatedData];

    let imageUrl = "";
    const filtered = schemaArray.filter((item: any) => {
      if (
        item.type === "IMG_LINK" &&
        typeof item.value === "string" &&
        item.value.trim() !== ""
      ) {
        imageUrl = item.value;
        return false;
      }
      return true;
    });

    setSchema(filtered);
    setImageLink(imageUrl);
    setData([]);
    return;
  }

  const infoArray = Object.keys(firstItem).map((key) => ({
    property: key,
    value: firstItem[key],
  }));

  const images = infoArray.filter(
    (obj) =>
      obj.property.toLowerCase() === "img_link" &&
      typeof obj.value === "string" &&
      obj.value.trim() !== ""
  );

  if (images.length > 0) {
    setImageLink(images[0].value);
    setData(infoArray.filter((obj) => obj.property.toLowerCase() !== "img_link"));
  } else {
    setImageLink("");
    setData(infoArray);
  }

  setSchema(undefined);
}, []);


  React.useEffect(() => {
    if (divRef.current) divRef.current.scrollTop = 0;
  }, [data]);

  return (
    <React.Fragment>    
      <ScannerForm
        module={modules.MODULE_PRODUCT}
        userDb={userDbId}
        updateData={updateData}
        onSubmit={isCustomProc ? getProductInfoCustom : getProductInfoByBarcode}
      />
     
      {imageLink && (
        <div>
          <Card>
            <CardMedia
              component="img"
              image={imageLink}
              className={classes.image}
              ref={refCallback}
              alt={String(translate("imageUploadFailed", "Nepavyko įkelti paveikslėlio"))}
            />
          </Card>

          <Backdrop open={zoomImage} className={classes.backdrop}>
            <img
              src={imageLink}
              height="100%"
              width="100%"
              className={classes.zoomedImage}
              ref={refCallback2}
              alt={translate(
                "imageUploadFailed",
                "Nepavyko įkelti paveikslėlio"
              )}
            />
          </Backdrop>
        </div>
      )}

      {schema ? (
        <div className={classes.schema}>         
          <DataView schema={schema} />          
        </div>
      ) : (
        
        <InfiniteScrollList
          initialData={data}
          loadDataparams={params}
          hideNoRowsLabel
        />
       
      )}
    </React.Fragment>
  );
}

export default ProductInfoForm;
